import { render } from "./VLotMenu.vue?vue&type=template&id=4091a146&scoped=true"
import script from "./VLotMenu.vue?vue&type=script&lang=js"
export * from "./VLotMenu.vue?vue&type=script&lang=js"

import "./VLotMenu.vue?vue&type=style&index=0&id=4091a146&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4091a146"]])

export default __exports__